export type currentStatusType =
  | "success"
  | "fail"
  | "loading"
  | "notRendering"
  | "waiting";
export interface CompositionStatusType {
  [index: number]: currentStatusType;
}
export enum renderStep {
  CreatingScene = "Creating Scene",
  Rendering = "Rendering to draft",
  UploadingImages = "Uploading Images to draft",
  UploadingVideos = "Uploading Videos to draft",
  UploadingAudio = "Uploading Audio to draft",
  UploadingFonts = "Uploading Fonts to draft",
  UploadingJson = "Uploading MP5 to draft",
  Idle = "",
}

export const uploadSteps = ["images", "videos", "audio", "fonts", "json"];

